"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = CloseButtonIcon;
var _react = _interopRequireDefault(require("react"));
var _svg;
function CloseButtonIcon() {
  return _svg || (_svg = /*#__PURE__*/_react["default"].createElement("svg", {
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 6.5625L0.9375 0L0 0.9375L6.5625 7.5L0 14.0625L0.9375 15L7.5 8.4375L14.0625 15L15 14.0625L8.4375 7.5L15 0.9375L14.0625 0L7.5 6.5625Z",
    fill: "black"
  })));
}